// Display metadata for the deployment switches reported by
// GET /api/admin/deployment-switches.
//
// It lives in a sibling constants module rather than in the card because a
// frontend file that exports both a component and a lookup table trips
// react-refresh/only-export-components and breaks Fast Refresh (CLAUDE.md,
// spec R6.7).
//
// This map is a display aid, NOT a whitelist: the card renders every switch the
// backend reports and falls back to the bare env-var name for anything missing
// here, so a switch added on the backend can never be silently dropped from the
// panel by a frontend that has not been updated.
//
// COORDINATION_BACKEND has no entry because the route deliberately does not
// report it: it is selected in the config bundle rather than the customer env
// file, so the environment-or-default source the payload carries could not be
// stated truthfully about it (utils/app_setup.py, _DEPLOYMENT_SWITCHES).
export const DEPLOYMENT_SWITCH_SUBSYSTEMS: Record<string, string> = {
  CONFIG_BACKEND: "Configuration source — file bundle or Azure App Configuration",
  COSMOS_BACKEND: "Chat history and metadata store — Mongo or Azure Cosmos DB",
  SEARCH_BACKEND: "Search index — Mongo or Azure AI Search",
  STORAGE_BACKEND: "Blob and table storage — Azurite or Azure Storage",
  QUEUE_BACKEND: "Background job transport — Redis or Azure",
  DOCINT_BACKEND: "Azure Document Intelligence parsing — azure or off",
  VIDEO_INDEXER_BACKEND: "Azure Video Indexer — azure or off",
}
